import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

export interface RedeemInvitationInput { code: string; profileId: string; }

interface Deps { membershipRepository: IMembershipRepository; }
export function createRedeemInvitationUseCase({ membershipRepository }: Deps) {
  return async function redeemInvitation(input: RedeemInvitationInput): Promise<void> {
    return membershipRepository.redeemInvitation(input.code, input.profileId);
  };
}